<template>
    <Loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page=false
        />
    <div class="pasarela">
        <form :action="urlPayU" method="post" name="form" ref="payU">
            <input name="merchantId"      type="hidden"  :value="merchant">
            <input name="accountId"       type="hidden"  :value="account">
            <input name="description"     type="hidden"  value="Pago suscripción NapoleoN Chat">
            <input name="referenceCode"   type="hidden"  :value="orden">
            <input name="amount"          type="hidden"  :value="amount">
            <input name="tax"             type="hidden"  value="0">
            <input name="taxReturnBase"   type="hidden"  value="0">
            <input name="currency"        type="hidden"  value="USD">
            <input name="signature"       type="hidden"  :value="code">
            <input name="test"            type="hidden"  value="0">
            <input name="buyerEmail"      type="hidden"  value="">
            <input name="responseUrl"     type="hidden"  :value="respose">
            <input name="confirmationUrl" type="hidden"  :value="respose">
        </form>
    </div>
</template>

<script>
import consta from "../globals/constUrl.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default {
    name: 'PasarelaView',
    data(){
        return {
            url: consta.serverSrc,
            urlPayU: consta.serverPayU,
            merchant: consta.merchant,
            account: consta.account,
            orden: this.$route.params.orden,
            amount: this.$route.params.amount,
            code: this.$route.params.code,
            respose: consta.myUrl + this.$route.params.user,
            isLoading: true,
            fullPage: true
        }
    },
    mounted(){
        this.$refs.payU.submit()
    },
    components: {
        Loading
    }
}
</script>